import React from 'react'
import PropTypes from 'prop-types'

import { List } from 'semantic-ui-react'

import { getEventTypeIcon, getEventTypeString } from './helpers'

const ChangelogEventItem = ({ item }) => (
  <List.Item>
    <List.Icon name={getEventTypeIcon(item.type)} />

    <List.Content>
      <List.Description>{getEventTypeString(item.type)}</List.Description>

      <List.Header>{item.headline}</List.Header>

      <List.Content>{item.description}</List.Content>
    </List.Content>
  </List.Item>
)

ChangelogEventItem.propTypes = {
  item: PropTypes.shape({
    description: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
}

export default ChangelogEventItem
